import { controls } from "../../controls";
const rprbi33 = {
  label: "Total Advances",
  starting: true,
  url: "Total Advances",
  pageLabel: "Total Advances",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "From Date", width: "col-sm-2", target: "from_date" }),
    ...controls.magicDate({ tab: "filter", name: "from_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),

    ...controls.magicDateLabel({ tab: "filter", label: "As on Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "RBI Total Advances",
    filterable: true,
    sortable: true,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },

    textReportProps: {
      'LBS': {
        filename: `RBI-Total_Advances-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    defaultsTo: 0,

    displayColumns: [
      {
        Header: "Branch Code",
        accessor: "branch_code",
      },
      {
        Header: "Branch Name",
        accessor: "branch_display",
      },
      {
        Header: "Advance at Rural Br.",
        accessor: "rural_advances",
      },
      {
        Header: "Advance at Semi Urban Br.",
        accessor: "semiurban_advances",
      },
      {
        Header: "Advance at Urban Br.",
        accessor: "urban_advances",
      },
      {
        Header: "TOTAL",
        accessor: "total_advances",
        // formula: [{
        //   f: 'simpleArithmatic', calcType: 'sum', inputs: [
        //     { source: 'row', field: 'rural_advances' }, { source: 'row', field: 'semiurban_advances' }, { source: 'row', field: 'urban_advances' }
        //   ], resultVar: 'total'
        // }]
      },
    ]
  }
};
export default rprbi33;